import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import InteractiveElement from 'nucleus-core/containers/InteractiveElement';
import Trigger from 'nucleus-core/containers/Trigger';
import Icon from '@cvent/nucleus-icon';
import { HAMBURGER, HORIZONTAL, TOPLEVEL, SUBLEVEL } from './Constants';
import { resolveTestId } from '@cvent/nucleus-test-automation';

/**
* Normal view for the website navigator.
*/
export default class WebsiteNavigator extends React.Component {
  static displayName = 'WebsiteNavigator';
  static propTypes = {
    selectedPage: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    }),
    pageData: PropTypes.array,
    navigateToPage: PropTypes.func,
    pageLinksArrangement: PropTypes.oneOf([HORIZONTAL, HAMBURGER]),
    leftContent: PropTypes.node,
    rightContent: PropTypes.node
  };
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);

    this.renderTrigger = this.renderTrigger.bind(this);
    this.renderMenuItem = this.renderMenuItem.bind(this);
    this.renderSubMenuOrItem = this.renderSubMenuOrItem.bind(this);
    this.renderNavigationMenu = this.renderNavigationMenu.bind(this);
  }
  onClick(id) {
    return () => {
      if (this.trigger) {
        this.trigger.handleHide();
      }
      this.props.navigateToPage(id);
    };
  }
  // Make trigger for dropdown or hamburger menu
  // Level switches the menu from a top level hamburger = 1 or other level, if not set defaults to 0..
  renderTrigger(menu, level, name, showAsSelectedGroup) {
    const { pageLinksArrangement, selectedPage, classes, style } = this.props;
    const containerClass = {
      ...classes,
      // eslint-disable-next-line
      transitionContainer: level === TOPLEVEL ?
      classes.transDropDown : pageLinksArrangement === HAMBURGER ? classes.transInline : classes.transDropDown
    };
    const showAsSelectedLink = level === TOPLEVEL || showAsSelectedGroup;
    let pageLinkStyles = resolve(this.props, 'pageLinks', showAsSelectedLink ? 'selected' : '');
    pageLinkStyles.style.textAlign = 'left';
    return (
      <Trigger classes={containerClass} style={style} allowMouse={false} isTriggerFocusable
        ref={(ref) => this.trigger = ref }>
        <div {...pageLinkStyles}>
          <span className={classes.selectedPage}>
            {name || selectedPage.name}
          </span>
          <Icon icon={level === TOPLEVEL ? 'menuFilled' : 'expand'} modifier={classes.menuIcon} />
        </div>
        {menu}
      </Trigger>
    );
  }
  // Individual link item
  renderMenuItem(page, menuType) {
    const { selectedPage } = this.props;
    let pageLinks = resolve(this.props, 'pageLinks', page.id === selectedPage.id ? 'selected' : '');
    pageLinks.style.textAlign = 'left';
    return (
      <li key={page.id} {...resolve(this.props, 'menuItem', menuType)}>
        <InteractiveElement {...pageLinks}
          onClick={this.onClick(page.id)}>
            {page.name}
        </InteractiveElement>
      </li>
    );
  }
  // Created Trigger and Sub Group pages
  renderSubMenuOrItem(item, menuType) {
    if (!item.childPages) {
      return this.renderMenuItem(item, menuType);
    }
    if (!item.childPages.length > 0) {
      return null;
    }
    const subMenu = (
      <ul {...resolve(this.props, 'subMenu', menuType)}>
        {item.childPages.map(childItem => this.renderSubMenuOrItem(childItem, 'sub'))}
      </ul>
    );
    const { selectedPage } = this.props;
    const selectedPageInGroup = item.childPages
      .map(childPage => childPage.id)
      .includes(selectedPage.id);
    return (
      <li key={item.id} {...resolve(this.props, 'menuItem', menuType)}>
        {this.renderTrigger(subMenu, SUBLEVEL, item.name, selectedPageInGroup)}
      </li>
    );
  }
  // Parent Navigation UL - Create sub menu or direct link...
  renderNavigationMenu() {
    const { pageData, pageLinksArrangement } = this.props;
    const textAlign = this.props.style.pageLinks.textAlign;
    const menuType = pageLinksArrangement === HAMBURGER ? 'vertical' : 'horizontal';
    return (
      <ul {...resolve(this.props, textAlign, 'menu', menuType)}>
        {pageData.map((item) => this.renderSubMenuOrItem(item, menuType))}
      </ul>
    );
  }
  render() {
    const { leftContent, rightContent, pageLinksArrangement } = this.props;
    // Create Parent Navigation Container - Hamburger for desktop check...
    let content;
    if (pageLinksArrangement === HAMBURGER) {
      content = (
        <div {...resolve(this.props, 'hamburgerWrapper')}>
          {this.renderTrigger(this.renderNavigationMenu(), TOPLEVEL)}
        </div>
      );
    } else {
      content = this.renderNavigationMenu();
    }
    return (
      <div {...resolveTestId(this.props)} { ...resolve(this.props, 'container')}>
        {leftContent &&
          <div { ...resolve(this.props, 'leftContent')}>
            {leftContent}
          </div>}
        <div { ...resolve(this.props, 'navigation')}>
          {content}
        </div>
        {rightContent &&
          <div { ...resolve(this.props, 'rightContent')}>
            {rightContent}
          </div>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./~/nucleus-widgets/lib/WebsiteNavigator/WebsiteNavigator.js